// 基础响应数据
const requestBaseData = {
  code: 0,
  reasonCode: 0,
  requestId: '1234567890',
  msg: 'success',
  time: new Date().getTime(),
  requiredVersion: {
    merchantWeb: '1.0.0',
    clientWeb: '1.0.0'
  },
};

// 聊天模块mock响应
const chatMockResponses = {
  '/api/brand/v1/chat/getMessages': {
    ...requestBaseData,
    data: {
      messages: [
        {
          id: '1',
          content: '您好，有什么可以帮助您的？',
          sender: 'assistant',
          timestamp: Date.now() - 3600000
        },
        {
          id: '2',
          content: '我想了解产品功能',
          sender: 'user',
          timestamp: Date.now() - 3000000
        }
      ]
    }
  },
  '/api/brand/v1/chat/sendMessage': {
    ...requestBaseData,
    data: {
      messageId: '3',
      status: 'sent'
    }
  }
};

export default chatMockResponses;
